'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'ProjectService',
    function ($modal, ProjectService) {

        return {
            getDisplayOperator: getDisplayOperator,
            getDisplayState: getDisplayState,
            reject: reject,
            rework: rework
        };

        // region Function

        function getDisplayOperator(operator) {
            switch (operator) {
                case "CREATE":
                    return "Создание";
                    break;
                case "UPDATE":
                    return "Обновление";
                    break;
                case "DELETE":
                    return "Удаление";
                    break;
            }
        }

        function getDisplayState(state) {
            switch (state) {
                case "APPROVED":
                    return "Одобрен";
                    break;
                case "REJECTED":
                    return "Отклонен";
                    break;
                case "REVIEWED":
                    return "На рассмотрении";
                    break;
                case "CANCELED":
                    return "Отменен";
                    break;
            }
        }

        function reject(transaction, callback) {
            return $modal.open({
                template: require('../view/project-transaction-modal-reject.html'),
                controller: 'ProjectTransactionModalRejectController',
                size: 'md',
                backdrop: false,
                resolve: {
                    transaction: function () {
                        return transaction;
                    }
                }
            }).result.then((transaction) => {
                ProjectService.api.reject({transactionId: transaction.id}, {
                    form: {
                        comment: transaction.comment
                    }
                }, callback)
            });
        }

        function rework(transaction, callback) {
            return $modal.open({
                template: require('../view/project-transaction-modal-rework.html'),
                controller: 'ProjectTransactionModalReworkController',
                size: 'md',
                backdrop: false,
                resolve: {
                    transaction: function () {
                        return transaction;
                    }
                }
            }).result.then((transaction) => {
                ProjectService.api.rework({transactionId: transaction.id}, {
                    form: {
                        comment: transaction.comment
                    }
                }, callback)
            });
        }

        // endregion

    }];